export default __webpack_public_path__ + "static/media/flute.84da62df.png";